import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';

import TableWithLocalPagination, { Column } from '../../../containers/Table/TableWithLocalPagination';
import Strings from '../../../Strings';
import { DATE_FORMAT_MONTH_NAME } from '../../../constants';
import '../CloudDocuments.scss';

function CloudContentTable(props) {
  const { canDelete, data, deleteHandler, downloadHandler, isLoading } = props;
  const sizeConverter = size => {
    if (size < 1000000) return `${Math.round((size / 1000 + Number.EPSILON) * 100) / 100} KB`;
    return `${Math.round((size / 1000000 + Number.EPSILON) * 100) / 100} MB`;
  };

  const columns = [
    <Column key="name" title={Strings.name} value={e => e.name} />,
    <Column
      key="created_at"
      title={Strings.created}
      value={e => moment(e.created_at).format(DATE_FORMAT_MONTH_NAME)}
      sortKey="created_at"
    />,
    <Column key="size" title={Strings.size} value={e => sizeConverter(e.size)} />,
  ];

  const download = (id, rowData) => {
    downloadHandler(rowData.name, rowData.org_id);
  };

  const buttons = [
    {
      icon: 'download',
      onClick: download,
      disabled: () => {
        return false;
      },
      text: Strings.download,
    },
    canDelete && {
      icon: 'delete',
      onClick: (_, rowData) => deleteHandler(rowData.name, rowData.org_id),
      text: Strings.delete,
    },
  ].filter(Boolean);

  return <TableWithLocalPagination isLoading={isLoading} data={data} columns={columns} buttons={buttons} />;
}

CloudContentTable.propTypes = {
  downloadHandler: PropTypes.func.isRequired,
  deleteHandler: PropTypes.func.isRequired,
  canDelete: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
};

export default CloudContentTable;
